import React from 'react';
import classnames from 'classnames';
import { textOverflow, translucent, strikethrough } from 'scy/utils.mod.scss';
import { Body } from 'scy/text';

export default function VolumeAndPrice({ volume, price, regularPrice }) {
  return (
    <Body className={textOverflow}>
      {volume}
      {price ? ' | ' : null}
      <PriceDisplay price={price} regularPrice={regularPrice} />
    </Body>
  );
}

function PriceDisplay({ price, regularPrice }) {
  const priceDisplay = price ? price.toFixed(2) : null;
  const regularPriceDisplay = regularPrice ? regularPrice.toFixed(2) : null;

  if (!priceDisplay) return null;

  return (
    <>
      {!!regularPriceDisplay && regularPriceDisplay !== priceDisplay && (
        <>
          <span className={classnames(translucent, strikethrough)}>
            ${regularPriceDisplay}
          </span>{' '}
        </>
      )}
      ${priceDisplay}
    </>
  );
}
